import QRCode from 'react-qr-code';

import { Typography } from '@components/atoms/Typography';
import { DownloadLink } from '@components/organisms/DownloadLink';
import { showAmount } from '@utils/currency';
import { createSingularLink } from '@utils/Singular';

import { TSummarySectionProps } from './types';

export const SummarySection = ({ amount, currency, paymentExternalId }: TSummarySectionProps) => {
  const urlToDownload = createSingularLink(paymentExternalId);

  return (
    <section className="rounded-xl w-[300px] justify-center p-6 flex flex-col gap-4 bg-white shadow-md">
      <div className="pricing flex-1 flex flex-col justify-center items-center">
        <Typography
          textKey="AstroPayDownload.signUpInSeconds"
          variant="h3"
          weight={500}
          className="text-[20px] hidden md:block"
        />

        <div className="qrcode hidden md:block py-4">
          <QRCode value={urlToDownload} size={110} />
        </div>

        {amount && currency && (
          <>
            <Typography
              textKey="AstroPayDownload.orderSummary"
              variant="span"
              weight={400}
              className="text-[#536663] text-[12px]"
            />
            <div className="totals flex flex-row gap-4">
              <Typography
                textKey="AstroPayDownload.orderTotal"
                variant="span"
                weight={400}
                className="md:flex-none flex-1"
              />
              <Typography
                text={showAmount({ value: amount, currency })}
                variant="span"
                weight={600}
              />
            </div>
          </>
        )}
        <div className="action">
          <DownloadLink
            action="openLink"
            className="md:hidden"
            paymentExternalId={paymentExternalId}
          />
        </div>
      </div>
    </section>
  );
};
